module.exports = __webpack_public_path__ + "img/wisa_mobile_01.f52ef03f.png";